import { Volume2 } from "lucide-react";

interface QuestionPlayerProps {
	questionText: string;
	questionKey: number;
}

/**
 * Renders the AI avatar and question card.
 *
 * Questions appear as static text with an opacity crossfade on transition.
 * No TTS, no word-by-word animation.
 */
export function QuestionPlayer({
	questionText,
	questionKey,
}: QuestionPlayerProps) {
	return (
		<div className="space-y-6">
			{/* AI Avatar — centered column */}
			<div className="flex flex-col items-center space-y-2">
				<div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center ring-2 ring-primary/20">
					<Volume2 className="h-5 w-5 text-primary" />
				</div>
				<p className="text-sm text-muted-foreground font-sans">
					Xander, Your AI Campaign Strategist
				</p>
			</div>

			{/* Question card — centered text, crossfade via key */}
			<div className="p-6 rounded-lg border border-primary/30 bg-primary/5 text-center">
				<p
					key={questionKey}
					className="text-2xl font-medium leading-relaxed text-foreground animate-in fade-in duration-150"
				>
					{questionText}
				</p>
			</div>
		</div>
	);
}
